import type { Season } from '../../engine/seasons/SeasonTypes';
import type { WorldGeneratorConfig, WorldSeed } from './types';
import { hashSeed } from './SeededRandom';

export interface CreateWorldGeneratorConfigInput {
  readonly kingdomId?: string;
  readonly width?: number;
  readonly height?: number;
  readonly visualPolish?: boolean;
  readonly waterMode?: 'tiles';
  readonly targetPhaseIndex?: number;
  readonly season?: Season;
}

export function createWorldSeed(kingdomId: string): WorldSeed {
  return {
    kingdomId,
    seed: hashSeed(kingdomId),
    createdAt: Date.now(),
  };
}

export function createWorldGeneratorConfig(input: CreateWorldGeneratorConfigInput = {}): WorldGeneratorConfig {
  const kingdomId = input.kingdomId ?? 'oldgamingman77-kingdom';
  return {
    width: input.width ?? 34,
    height: input.height ?? 20,
    seed: createWorldSeed(kingdomId),
    visualPolish: Boolean(input.visualPolish),
    waterMode: 'tiles',
    targetPhaseIndex: input.targetPhaseIndex ?? 1,
    season: input.season,
  };
}
